import { render, staticRenderFns } from "./viewPathes.vue?vue&type=template&id=c58b0332&scoped=true"
import script from "./viewPathes.vue?vue&type=script&lang=js"
export * from "./viewPathes.vue?vue&type=script&lang=js"
import style0 from "./viewPathes.vue?vue&type=style&index=0&id=c58b0332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b0332",
  null
  
)

export default component.exports